import axios from "axios";

let ENDPOINT = "/orderkiosk/api";
let LOCAL_WEBSERVER_WEBCACHE_URL = "http://localhost:8080/webCache/rq";

let env = process.env.NODE_ENV || "development";
if (env !== "production") {
  ENDPOINT = "/orderkiosk/api";
  LOCAL_WEBSERVER_WEBCACHE_URL = "/webCache/rq";
}

export function localWebserverWebCache() {
  return axios.create({
    baseURL: LOCAL_WEBSERVER_WEBCACHE_URL,
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    timeout: 10000
  });
}

export function baseApi() {
  return axios.create({
    baseURL: ENDPOINT,
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    timeout: 60000
  });
}

export default {
  getLanguage(url) {
    let p = axios.create({
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      timeout: 300000
    });
    return p.get(url);
  },
  getLanguages() {
    return baseApi().get("/languages");
  },
  getExtras() {
    return baseApi().get("/extras");
  },
  getDeliveryMethods() {
    return baseApi().get("/delivery_methods");
  },
  getProducts() {
    return baseApi().get("/products");
  },
  getProductAttributes() {
    return baseApi().get("/product_attributes");
  },
  getProductFilters() {
    return baseApi().get("/product_filters");
  },
  getCategories() {
    return baseApi().get("/categories");
  },
  getMenus() {
    return baseApi().get("/menus");
  },
  getPromos() {
    return baseApi().get("/promos");
  },
  getScreenssavers() {
    return baseApi().get("/screensavers");
  },
  getSchedule() {
    return baseApi().get("/schedule");
  },
  getSiteSetting() {
    return baseApi().get("/site_setting");
  },
  getCustomHomeSetting() {
    return baseApi().get("/custom_home_setting");
  },
  getOffers() {
    return baseApi().get("/offers");
  },
  postQrCode(qrcode) {
    let p = axios.create({
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      responseType: "blob",
      timeout: 5000
    });
    return p.post(ENDPOINT + "/qrcode", qrcode);
  },
  postPager(pager) {
    return baseApi().post("/pager", pager);
  },
  postBasket(basket) {
    return baseApi().post("/basket", basket);
  },
  reprintReceipt() {
    return baseApi().get("/print_last_customer_receipt");
  },
  switchPoleLight(color = "white") {
    return baseApi().get("/switch_pole_light/" + color);
  },
  getDeployment() {
    return baseApi().get("/deployment");
  },
  postDeployment(deployment) {
    return baseApi().post("/deployment", deployment);
  },
  getPuckInfo() {
    return baseApi().post("/puckinfo");
  },
  getPuckOperation(basket) {
    return baseApi().post("/puckoperation", basket);
  },
  getServerInfo() {
    return baseApi().post("/serverinfo");
  }
};
